import { Dispatch } from "../../controller";
import { Model,StateProps } from "../../model";
import { Pessoa,TipoPessoa } from "../../data.types";

export interface Fornecedor extends Pessoa {}

export interface FornecedorState extends StateProps<Fornecedor> {
 
}

export interface FornecedorActions extends Dispatch<Fornecedor> {

}

const model = new Model<Pessoa,FornecedorState>(TipoPessoa.fornecedor);

const intialValueFornecedor:Fornecedor = {
    ...model.getInitialValue(),
    type:TipoPessoa.fornecedor,
    apelido:"",
    nome:"",
    sobrenome:"",
    email:"",
    tipo_doc:"CNPJ",
    enderecos:[],
    idx_endereco_main:0,
    fone:"",
    n_doc:"",
    senha:"",
    whatsapp:"",
}

export const initialValueState:FornecedorState = {
    ...model.getInititalValueState(),
    row:intialValueFornecedor,
}


